import { Component } from '@angular/core';
import { InputGLobal } from '../utils/input-global';

@Component({
  selector: 'lib-input-email',
  templateUrl: './input-email.component.html',
  styleUrl: './input-email.component.scss',
})
export class InputEmailComponent extends InputGLobal {}
